import { render, staticRenderFns } from "./TodoHeader.vue?vue&type=template&id=57219b6e&scoped=true&"
import script from "./TodoHeader.vue?vue&type=script&lang=js&"
export * from "./TodoHeader.vue?vue&type=script&lang=js&"
import style0 from "./TodoHeader.vue?vue&type=style&index=0&id=57219b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57219b6e",
  null
  
)

export default component.exports